import { motion } from "framer-motion";
import styled from "styled-components";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";
import { FONT_SIZE } from "../../constants/design/fontSize";

// --- Modal Header ---

export const ShareModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${SPACING.three}px ${SPACING.three}px;
  border-bottom: 1px solid ${BORDER_COLORS.one};

  > span {
    font-size: ${FONT_SIZE.two};
    font-weight: 600;
    color: ${TEXT_COLORS.one};
  }
`;

export const ShareHeaderActions = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: ${BORDER_RADIUS.three}px;
  border: 1px solid ${BORDER_COLORS.one};
  background: ${LAYER_COLORS.two};
  cursor: pointer;
  color: ${TEXT_COLORS.two};
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${LAYER_COLORS.three};
    color: ${TEXT_COLORS.one};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// --- Controls Section ---

export const ControlsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.four}px;
  padding: ${SPACING.three}px ${SPACING.three}px;
  border-top: 1px solid ${BORDER_COLORS.one};
`;

export const ControlGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.two}px;

  > label {
    font-size: 10px;
    font-weight: 600;
    color: ${TEXT_COLORS.three};
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
`;

export const ControlButtonRow = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
`;

export const ControlIconBtn = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: ${BORDER_RADIUS.three}px;
  border: 1px solid
    ${({ active }) => (active ? COLORS.highlight.one : BORDER_COLORS.one)};
  background: ${({ active }) =>
    active ? COLORS.highlight.five : LAYER_COLORS.two};
  cursor: pointer;
  color: ${({ active }) => (active ? COLORS.highlight.one : TEXT_COLORS.two)};
  transition: all 0.15s;

  &:hover {
    border-color: ${COLORS.highlight.two};
    color: ${TEXT_COLORS.one};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

// Colored dot for background option
export const BgDot = styled.div<{ $color: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

// --- Action Row ---

export const ShareActionsRow = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
  padding: ${SPACING.three}px;
  border-top: 1px solid ${BORDER_COLORS.one};
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: ${BORDER_RADIUS.four}px;
  border: 1px solid ${BORDER_COLORS.one};
  background: transparent;
  color: ${TEXT_COLORS.two};
  font-size: ${FONT_SIZE.two};
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${LAYER_COLORS.two};
    color: ${TEXT_COLORS.one};
  }
`;

export const TwitterButton = styled.button`
  flex: 2;
  height: 44px;
  border-radius: ${BORDER_RADIUS.four}px;
  border: none;
  background: ${TEXT_COLORS.one};
  color: ${BACKGROUND_COLORS.one};
  font-size: ${FONT_SIZE.two};
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.88;
  }
`;

// --- Hidden export target ---

export const EnlargedPnLCardContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

export const EnlargedPnLCardWrapper = styled.div`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  left: -9999px;
  top: -9999px;
  width: 640px;
  height: 400px;
  background: ${BACKGROUND_COLORS.one};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

// Legacy exports kept for compatibility
export const SharePreviewTitle = styled.div``;
export const PnLCardWrapper = styled.div``;
export const MiniCardWrapper = styled.div``;
export const MiniTopCard = styled.div``;
export const MiniBottomCard = styled.div``;
export const QRWrapper = styled.div``;
export const MiniAsset = styled.img``;
export const MiniTitle = styled.div``;
export const MiniText = styled(motion.div)<{ color?: string }>``;
export const MiniStatWrapper = styled.div``;
export const EnlargedTitle = styled(motion.div)<{ color?: string }>``;
export const EnlargedStatWrapper = styled.div``;
export const EnlargedTopCard = styled.div``;
